module.exports = __webpack_public_path__ + "img/high.e8e6d82f.svg";